// Pure frame-lookup helpers over the `frames` array returned by
// GET history/frames (see the API contract): `frames` is sorted ascending by
// `t` (ms bucket-start) and never contains an empty bucket.

/**
 * The frame in effect at `playheadMs`: the LATEST frame with `t <= playheadMs`.
 * Returns null when no frame precedes the playhead (nothing loaded yet, or
 * the playhead sits before the first bucket).
 */
export const resolveFrame = (frames, playheadMs) => {
  if (!Array.isArray(frames) || frames.length === 0 || playheadMs == null) {
    return null;
  }
  let result = null;
  for (const frame of frames) {
    if (frame.t <= playheadMs) {
      result = frame;
    } else {
      break;
    }
  }
  return result;
};

/**
 * Up to `count` frames strictly before `frame` (by `t`), nearest first.
 * This is the "previous 5 buckets" window buildCanvasPersonnel ghosts a
 * missing subject against. Frames omit empty buckets entirely, so this walks
 * actual data points rather than strict `interval`-spaced bucket slots.
 */
export const getPrecedingFrames = (frames, frame, count = 5) => {
  if (!Array.isArray(frames) || !frame) return [];
  const idx = frames.indexOf(frame);
  const startIdx = idx >= 0 ? idx : frames.filter((f) => f.t < frame.t).length;
  const preceding = [];
  for (let i = startIdx - 1; i >= 0 && preceding.length < count; i -= 1) {
    if (frames[i].t < frame.t) preceding.push(frames[i]);
  }
  return preceding;
};
